import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import config from './config'

const PrivateRoute = () => {
  return <Outlet />;
};

export default PrivateRoute;